import React from "react";
import { SVGAsset } from 'res';
import "./styles.css";

export default function ProgressionBarWidget(props) {
    return (
        <div className="progression-bar-widget flex-container flex-horizontal all-center">
            {props.children}
        </div>
    )
}

export function ProgressionStep(props) {
    const activeClass = props.activeClass ?? "";
    const completedClass = props.completedClass ?? "";

    return (
        <div className={"set-width progression-step " + activeClass + " " + completedClass}>
            <div className="outer-circle orange-circle">
                <div className="circle"></div>
            </div>
            <div className="outer-circle gray-circle">
                <div className="circle"></div>
            </div>
            <SVGAsset id="CircleCheckmarkIcon" className="icon circle-checkmark-icon" />
        </div>
    )
}
